import React from 'react';

import { QueryProvider } from '@thd-nucleus/data-sources';
import { useStore } from '@thd-nucleus/experience-context';
import { Collections } from './Collections';

export const CollectionsContainer = (props) => {
  const store = useStore();
  const { storeId } = store;
  const defaultVariables = {
    storeId
  };

  return (
    <QueryProvider
      cacheKey="collections-page"
      defaultVariables={defaultVariables}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Collections {...props} />
    </QueryProvider>
  );

};

CollectionsContainer.propTypes = {};
